import React from 'react'
import { PatternFormat } from 'react-number-format'

const FormatPhoneNumber = ({ fieldName, value }) => {
  return (
    <PatternFormat
      name={fieldName}
      format='(###) ###-####'
      mask='_'
      value={value || ''}
    />
  )
}

export default FormatPhoneNumber
